import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";

// Mirrors apps/api/src/routes/portfolio.ts (house style: types duplicated
// client-side, cf. use-insights.ts).
export type AttentionReason =
  | "autopilot_paused"
  | "ads_paused"
  | "failed_posts"
  | "ai_budget"
  | "ads_budget";

export interface PortfolioBrand {
  id: string;
  name: string;
  slug: string;
  logoUrl: string | null;
  role: string;
  pendingReview: number;
  scheduledNext7d: number;
  failedPosts7d: number;
  automation: {
    autopilot: { enabled: boolean; pausedAt: string | null; pauseReason: string | null };
    ads: { enabled: boolean; mode: "suggest" | "auto"; pausedAt: string | null; pauseReason: string | null };
    inboxAutoReply: { enabled: boolean };
    aiReview: { enabled: boolean; autoApprove: boolean };
    autoSchedule: { enabled: boolean };
  };
  aiSpend: { spentUsd: string; capUsd: string | null; percentUsed: number };
  adSpend: { committedUsd: string; capUsd: string | null; percentUsed: number };
  latestInsight: { summary: string; createdAt: string } | null;
  needsAttention: AttentionReason[];
}

export function usePortfolio() {
  return useQuery({
    queryKey: ["portfolio"],
    queryFn: () => apiFetch<{ brands: PortfolioBrand[] }>("/portfolio"),
    staleTime: 30_000,
  });
}
